module.exports = __webpack_public_path__ + "43539edb97c6a7d7e1a98f9a3e4c34ad.svg";